<template>
  <el-dialog
    :title="`${dialog_type} Track`"
    :visible="dialog"
    width="600px"
    top="8vh"
    :modal="true"
    :close-on-click-modal="false"
    @close="close"
    @open="open"
  >
    <div class="image">
      <div v-if="!image && !previewImage" class="image--uploader">
        <label for="imageFile" class="image-uploader"><i class="el-icon-plus fa-2x"></i></label>
        <input type="file" id="imageFile" accept="image/png, image/jpeg, image/jpg" v-show="false" @change="uploadImage">
      </div>
      <div v-else class="image--preview">
        <img height="120" width="120" :src="image ? image : previewImage" alt="image">
        <div class="overlay" @click="removeImage">
          <el-button
              class="btn-remove"
              icon="fas fa-trash"
              circle
          ></el-button>
        </div>
      </div>
    </div>
    <el-form ref="track" :model="track" label-position="top" class="form-wrapper">
      <el-form-item label="Title" prop="title">
        <el-input type="text" v-model="track.title" clearable />
      </el-form-item>
      <el-form-item label="Featured" prop="featured">
        <el-switch
          v-model="track.featured"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-text="Yes"
          inactive-text="No"
          :active-value="1"
          :inactive-value="0"
        ></el-switch>
      </el-form-item>
      <el-form-item  label="Leaderboard" prop="leaderboard">
        <el-switch
          v-model="track.leaderboard"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-text="Yes"
          inactive-text="No"
          :active-value="1"
          :inactive-value="0"
        ></el-switch>
      </el-form-item>
      <el-form-item
        label="Artist"
        prop="artist_id"
        :rules="[{ required: true, message: 'artist is required' }]"
      >
        <el-select v-model="track.artist_id" clearable filterable class="w100">
          <el-option
            v-for="a in artists"
            :key="a.id"
            :value="a.id"
            :label="a.name"
          ></el-option>
        </el-select>
      </el-form-item>
<!--      <el-form-item  label="Affiliate link generator" prop="affiliate_generator">
        <el-switch
          v-model="track.affiliate_generator"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-text="Yes"
          inactive-text="No"
          :active-value="1"
          :inactive-value="0"
        ></el-switch>
      </el-form-item>-->
      <el-form-item label="Affiliate SignUp link generator" prop="signup_generator">
        <el-switch
            v-model="track.affiliate_signup_generator"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="Yes"
            inactive-text="No"
            :active-value="1"
            :inactive-value="0"
            @change="handleSwitchChange('signup_generator')"
        ></el-switch>
      </el-form-item>
      <el-form-item label="Affiliate Streaming link generator" prop="streaming_generator">
        <el-switch
            v-model="track.affiliate_track_generator"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="Yes"
            inactive-text="No"
            :active-value="1"
            :inactive-value="0"
            @change="handleSwitchChange('track_generator')"
        ></el-switch>
      </el-form-item>
      <el-form-item v-if="track.affiliate_track_generator === 1" label="Upload XLS File">
        <el-upload
            class="upload-demo"
            :action="url + 'talent-scout/track/affiliate/' + track.id"
            :headers="headers"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            :before-upload="beforeUpload"
            drag
        >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
        </el-upload>
      </el-form-item>
      <el-form-item label="Platforms" prop="type">
        <el-select v-model="track.socials" filterable multiple class="mr10 capitalize">
          <el-option v-for="social in socials" :key="social.id" :value="social.id" :label="social.name"></el-option>
        </el-select>
      </el-form-item>
      <div class="tiktok_data" v-if="hasSocial('TikTok')">
        <div  class="custom-form-title">
          <label class="custom-label">TikTok Challenge</label>
          <el-button class="circle-button" type="default" @click="tiktokStatus(tiktokData)"
                     :icon="tiktokData === true ? 'el-icon-top' : 'el-icon-bottom'"
                     circle></el-button>
        </div>
        <div v-if="tiktokData" class ="social-data tiktok-bar">
          <el-form-item label="" class="position">
            <el-switch  v-model="track.tiktok_challenge.multiple_submissions" active-text="Multiple submissions" inactive-text=""
                       active-color="#13ce66" inactive-color="#df2758"></el-switch>
          </el-form-item>
          <el-form-item label="Budget ($)" prop="tiktok_challenge.budget">
            <el-input type="number" v-model="track.tiktok_challenge.budget" clearable />
          </el-form-item>
          <el-form-item class="item-dropdown">
            <div class="custom-form-title">
              <label class="custom-label">Pricing thresholds</label>
              <el-button type="default"
                         class="circle-button"
                         @click="showTikTokPricing = !showTikTokPricing"
                         :icon="showTikTokPricing === true ? 'el-icon-top' : 'el-icon-bottom'"
                         circle></el-button>
            </div>

            <el-table :data="track.tiktok_pricing" v-if="showTikTokPricing">
              <el-table-column label="Thresholds">
                <template slot-scope="scope">
                  {{ scope.row.threshold.toString() }}
                </template>
              </el-table-column>
              <el-table-column label="Value ($)">
                <template slot-scope="scope">
                  <el-form-item class="pricing-input"
                                :prop="'tiktok_pricing' + scope.row.id + 'value'">
                    <el-input v-model="scope.row.payment"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item class="item-dropdown">
            <div class="custom-form-title">
              <label class="custom-label">Additional perks</label>
              <el-button type="default" @click="showTikTokPerks = !showTikTokPerks"
                         class="circle-button"
                         :icon="showTikTokPerks === true ? 'el-icon-top' : 'el-icon-bottom'"
                         circle></el-button>
            </div>
            <div v-if="showTikTokPerks" class="perks">
              <el-form-item label="Early Bird Description" prop="tiktok_challenge.guaranteed_desc">
                <el-input type="text" v-model="track.tiktok_challenge.guaranteed_desc" clearable />
              </el-form-item>
              <el-form-item label="Early Bird Payment" prop="tiktok_challenge.guaranteed_payment">
                <el-input type="number" v-model="track.tiktok_challenge.guaranteed_payment" clearable />
              </el-form-item>
              <el-form-item label="Bonus Title" class="position">
                <el-input v-model="track.tiktok_challenge.bonus_title"></el-input>
              </el-form-item>
              <el-form-item label="Bonus Description" prop="tiktok_challenge.bonus_desc">
                <el-input type="text" v-model="track.tiktok_challenge.bonus_desc" clearable />
              </el-form-item>
              <el-form-item label="Shoutout Description" class="position">
                <el-input v-model="track.tiktok_challenge.shoutout_desc" class="position"/>
              </el-form-item>
              <el-form-item label="Shoutout amount" class="position">
                <el-input type="number" v-model="track.tiktok_challenge.shoutout_payment"></el-input>
              </el-form-item>
              <el-form-item label="Affiliate Description" class="position">
                <el-input v-model="track.tiktok_challenge.affiliate_desc" class="position"/>
              </el-form-item>
              <el-form-item label="Discount Description" class="position">
                <el-input v-model="track.tiktok_challenge.discount_desc" class="position"/>
              </el-form-item>
              <el-form-item label="Discount percentage" class="position">
                <el-input type="number" v-model="track.tiktok_challenge.discount_value"></el-input>
              </el-form-item>
<!--              <el-form-item label="Bonus payment" prop="tiktok_challenge.bonus_payment">
                <el-input type="number" v-model="track.tiktok_challenge.bonus_payment" clearable />
              </el-form-item>-->
<!--              <el-form-item label="Earn Up" prop="tiktok_challenge.earn_up">
                <el-input type="text" v-model="track.tiktok_challenge.earn_up" clearable />
              </el-form-item>
              <el-form-item label="Free To Use" prop="tiktok_challenge.free_to_use">
                <el-input type="text" v-model="track.tiktok_challenge.free_to_use" clearable />
              </el-form-item>-->
            </div>
          </el-form-item>
          <el-form-item class ="item-dropdown">
            <div class="custom-form-title">
              <label class="custom-label">Campaign availability</label>
              <el-button type="default" @click="showTikTokCampaignAvailability = !showTikTokCampaignAvailability"
                         class="circle-button"
                         :icon="showTikTokCampaignAvailability === true ? 'el-icon-top' : 'el-icon-bottom'"
                         circle></el-button>
            </div>
            <div v-if="showTikTokCampaignAvailability">
              <el-form-item label="" class="position">
                <el-switch class="modal__affiliate" v-model="track.tiktok_challenge.allow_rejected_user" active-text="Rejected users" inactive-text=""
                           active-color="#13ce66" inactive-color="#df2758"></el-switch>
              </el-form-item>
              <el-form-item label="" class="position">
                <el-switch class="modal__affiliate" v-model="track.tiktok_challenge.allow_pending_user" active-text="Pending users" inactive-text=""
                           active-color="#13ce66" inactive-color="#df2758"></el-switch>
              </el-form-item>
            </div>
          </el-form-item>
          <div class="upload-content">
            <div class="upload-title" v-if="!track.tiktok_challenge.video">Content example</div>
            <el-upload
              v-if="!track.tiktok_challenge.video"
              drag
              ref="uploadChallengeVideo"
              :action="url + 'talent-scout/track/video/' + track.id"
              :headers="headers"
              :limit="1"
              name="video"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Drop file here or <em>click to upload</em>
              </div>
              <div class="el-upload__tip" slot="tip">*upload image or video</div>
            </el-upload>
            <el-form-item v-else label="Uploaded content" class="video-wrap">
              <div>
                <a :href="track.tiktok_challenge.video" target="_blank">
                  {{ getOriginalVideoName(track.tiktok_challenge.video) }}
                </a>
                <i class="el-icon-circle-close pointer ml5" @click="deleteVideo(track.id)"></i>
              </div>
            </el-form-item>
          </div>
          <el-form-item label="Link to sound" prop="tiktok_challenge.link">
            <el-input type="text" v-model="track.tiktok_challenge.link" clearable />
          </el-form-item>
<!--          <el-form-item label="Steps title" prop="tiktok_challenge.campaign_main_title">
            <el-input type="text" v-model="track.tiktok_challenge.campaign_main_title" clearable />
          </el-form-item>-->
          <el-form-item label="Steps" prop="tiktok_challenge.steps">
            <vue-editor v-model="track.tiktok_challenge.steps"  />
          </el-form-item>
          <el-form-item label="Top tips" prop="tiktok_challenge.top_tips">
            <vue-editor v-model="track.tiktok_challenge.top_tips"  />
          </el-form-item>
          <el-form-item
            label="Challenge Date"
            prop="tiktok_challenge.date_start"
            style="margin-bottom: 25px;"
          >
            <el-input
              type="hidden"
              v-model="track.tiktok_challenge.date_start"
              clearable
              style="width: 0px;"
            />
            <el-date-picker
              v-model="tiktokDatePicker"
              type="daterange"
              format="d MMMM yyyy"
              value-format="yyyy-MM-dd"
              range-separator="-"
              start-placeholder="Start date"
              end-placeholder="End date"
              @change="changeTikTokPicker"
            ></el-date-picker>
          </el-form-item>
        </div>
      </div>
      <!--instagram challenge-->
      <div class="instagram_data" v-if="hasSocial('Instagram')">
        <div  class="custom-form-title">
          <label class="custom-label">Instagram Challenge</label>
          <el-button class="circle-button" type="default" @click="instagramStatus(instagramData)"
                     :icon="instagramData === true ? 'el-icon-top' : 'el-icon-bottom'"
                     circle></el-button>
        </div>
        <div v-if="instagramData" class ="social-data instagram-bar">
          <el-form-item label="" class="position">
            <el-switch  v-model="track.instagram_challenge.multiple_submissions" active-text="Multiple submissions" inactive-text=""
                        active-color="#13ce66" inactive-color="#df2758"></el-switch>
          </el-form-item>
          <el-form-item label="Budget ($)" prop="instagram_challenge.budget">
            <el-input type="number" v-model="track.instagram_challenge.budget" clearable />
          </el-form-item>
          <el-form-item class="item-dropdown">
            <div class="custom-form-title">
              <label class="custom-label">Pricing thresholds</label>
              <el-button type="default"
                         class="circle-button"
                         @click="showInstagramPricing = !showInstagramPricing"
                         :icon="showInstagramPricing === true ? 'el-icon-top' : 'el-icon-bottom'"
                         circle></el-button>
            </div>

            <el-table :data="track.instagram_pricing" v-if="showInstagramPricing">
              <el-table-column label="Thresholds">
                <template slot-scope="scope">
                  {{ scope.row.threshold.toString() }}
                </template>
              </el-table-column>
              <el-table-column label="Value ($)">
                <template slot-scope="scope">
                  <el-form-item class="pricing-input"
                                :prop="'instagram_price' + scope.row.id + 'value'">
                    <el-input v-model="scope.row.payment"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item class ="item-dropdown">
            <div class="custom-form-title">
              <label class="custom-label">Additional perks</label>
              <el-button type="default" @click="showInstagramPerks = !showInstagramPerks"
                         class="circle-button"
                         :icon="showInstagramPerks === true ? 'el-icon-top' : 'el-icon-bottom'"
                         circle></el-button>
            </div>
            <div v-if="showInstagramPerks" class="perks">
              <el-form-item label="Early Bird Description" prop="tiktok_challenge.guaranteed_desc">
                <el-input type="text" v-model="track.instagram_challenge.guaranteed_desc" clearable />
              </el-form-item>
              <el-form-item label="Early Bird Payment" prop="tiktok_challenge.guaranteed_payment">
                <el-input type="number" v-model="track.instagram_challenge.guaranteed_payment" clearable />
              </el-form-item>
              <el-form-item label="Bonus Title" class="position">
                <el-input v-model="track.instagram_challenge.bonus_title"></el-input>
              </el-form-item>
              <el-form-item label="Bonus Description" prop="tiktok_challenge.bonus_desc">
                <el-input type="text" v-model="track.instagram_challenge.bonus_desc" clearable />
              </el-form-item>
              <el-form-item label="Shoutout Description" class="position">
                <el-input v-model="track.instagram_challenge.shoutout_desc" class="position"/>
              </el-form-item>
              <el-form-item label="Shoutout amount" class="position">
                <el-input type="number" v-model="track.instagram_challenge.shoutout_payment"></el-input>
              </el-form-item>
              <el-form-item label="Affiliate Description" class="position">
                <el-input v-model="track.instagram_challenge.affiliate_desc" class="position"/>
              </el-form-item>
              <el-form-item label="Discount Description" class="position">
                <el-input v-model="track.instagram_challenge.discount_desc" class="position"/>
              </el-form-item>
              <el-form-item label="Discount percentage" class="position">
                <el-input type="number" v-model="track.instagram_challenge.discount_value"></el-input>
              </el-form-item>

<!--              <el-form-item label="Earn Up" prop="instagram_challenge.earn_up">
                <el-input type="text" v-model="track.instagram_challenge.earn_up" clearable />
              </el-form-item>
              <el-form-item label="Free To Use" prop="instagram_challenge.free_to_use">
                <el-input type="text" v-model="track.instagram_challenge.free_to_use" clearable />
              </el-form-item>-->
            </div>
          </el-form-item>
          <el-form-item class ="item-dropdown">
            <div class="custom-form-title">
              <label class="custom-label">Campaign availability</label>
              <el-button type="default" @click="showInstagramCampaignAvailability = !showInstagramCampaignAvailability"
                         class="circle-button"
                         :icon="showInstagramCampaignAvailability === true ? 'el-icon-top' : 'el-icon-bottom'"
                         circle></el-button>
            </div>
            <div v-if="showInstagramCampaignAvailability">Adding new user type for "Campaign highlight" carousel
              <el-form-item label="" class="position">
                <el-switch class="modal__affiliate" v-model="track.instagram_challenge.allow_rejected_user" active-text="Rejected users" inactive-text=""
                           active-color="#13ce66" inactive-color="#df2758"></el-switch>
              </el-form-item>
              <el-form-item label="" class="position">
                <el-switch class="modal__affiliate" v-model="track.instagram_challenge.allow_pending_user" active-text="Pending users" inactive-text=""
                           active-color="#13ce66" inactive-color="#df2758"></el-switch>
              </el-form-item>
            </div>
          </el-form-item>
          <div>
            <div class="upload-content">
              <div class="upload-title" v-if="!track.instagram_challenge.video">Content example</div>
              <el-upload
                v-if="!track.instagram_challenge.video"
                drag
                ref="uploadChallengeVideo"
                :action="url + 'instagram-challenge/video/' + track.id"
                :headers="headers"
                :limit="1"
                name="video"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  Drop file here or <em>click to upload</em>
                </div>
                <div class="el-upload__tip" slot="tip">*upload image or video</div>
              </el-upload>
              <el-form-item v-else label="Uploaded content" class="video-wrap">
                <div>
                  <a :href="track.instagram_challenge.video" target="_blank">
                    {{ getOriginalVideoName(track.instagram_challenge.video) }}
                  </a>
                  <i class="el-icon-circle-close pointer ml5" @click="deleteInstagramVideo(track.id)"></i>
                </div>
              </el-form-item>
            </div>
          </div>
          <el-form-item label="Link to sound" prop="instagram_challenge.link">
            <el-input type="text" v-model="track.instagram_challenge.link" clearable />
          </el-form-item>
<!--          <el-form-item label="Steps title" prop="instagram_challenge.campaign_main_title">
            <el-input type="text" v-model="track.instagram_challenge.campaign_main_title" clearable />
          </el-form-item>-->
          <el-form-item label="Steps" prop="instagram_challenge.steps">
            <vue-editor v-model="track.instagram_challenge.steps" />
          </el-form-item>
          <el-form-item label="Top tips" prop="instagram_challenge.top_tips">
            <vue-editor v-model="track.instagram_challenge.top_tips" />
          </el-form-item>
          <el-form-item
            label="Challenge Date"
            prop="instagram_challenge.date_start"
            style="margin-bottom: 25px;"
          >
            <el-input
              type="hidden"
              v-model="track.instagram_challenge.date_start"
              clearable
              style="width: 0px;"
            />
            <el-date-picker
              v-model="instagramDatePicker"
              type="daterange"
              format="d MMMM yyyy"
              value-format="yyyy-MM-dd"
              range-separator="-"
              start-placeholder="Start date"
              end-placeholder="End date"
              @change="changeInstagramPicker"
            ></el-date-picker>
          </el-form-item>
        </div>
      </div>
      <!--shorts challenge-->
      <div class="shorts_data" v-if="hasSocial('YouTube Short')">
        <div  class="custom-form-title">
          <label class="custom-label">YouTube Short Challenge</label>
          <el-button class="circle-button" type="default" @click="shortsStatus(shortsData)"
                     :icon="shortsData === true ? 'el-icon-top' : 'el-icon-bottom'"
                     circle></el-button>
        </div>
        <div v-if="shortsData" class ="social-data shorts-bar">
          <el-form-item label="" class="position">
            <el-switch  v-model="track.short_challenge.multiple_submissions" active-text="Multiple submissions" inactive-text=""
                        active-color="#13ce66" inactive-color="#df2758"></el-switch>
          </el-form-item>
          <el-form-item label="Budget ($)" prop="short_challenge.budget">
            <el-input type="number" v-model="track.short_challenge.budget" clearable />
          </el-form-item>
          <el-form-item class="item-dropdown">
            <div class="custom-form-title">
              <label class="custom-label">Pricing thresholds</label>
              <el-button type="default"
                         class="circle-button"
                         @click="showShortsPricing = !showShortsPricing"
                         :icon="showShortsPricing === true ? 'el-icon-top' : 'el-icon-bottom'"
                         circle></el-button>
            </div>

            <el-table :data="track.short_pricing" v-if="showShortsPricing">
              <el-table-column label="Thresholds">
                <template slot-scope="scope">
                  {{ scope.row.threshold.toString() }}
                </template>
              </el-table-column>
              <el-table-column label="Value ($)">
                <template slot-scope="scope">
                  <el-form-item class="pricing-input"
                                :prop="'short_pricing' + scope.row.id + 'value'">
                    <el-input v-model="scope.row.payment"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item class="item-dropdown">
            <div class="custom-form-title">
              <label class="custom-label">Additional perks</label>
              <el-button type="default" @click="showShortsPerks = !showShortsPerks"
                         class="circle-button"
                         :icon="showShortsPerks === true ? 'el-icon-top' : 'el-icon-bottom'"
                         circle></el-button>
            </div>
            <div v-if="showShortsPerks" class="perks">
              <el-form-item label="Early Bird Description" prop="tiktok_challenge.guaranteed_desc">
                <el-input type="text" v-model="track.short_challenge.guaranteed_desc" clearable />
              </el-form-item>
              <el-form-item label="Early Bird Payment" prop="tiktok_challenge.guaranteed_payment">
                <el-input type="number" v-model="track.short_challenge.guaranteed_payment" clearable />
              </el-form-item>
              <el-form-item label="Bonus Title" class="position">
                <el-input v-model="track.short_challenge.bonus_title"></el-input>
              </el-form-item>
              <el-form-item label="Bonus Description" prop="tiktok_challenge.bonus_desc">
                <el-input type="text" v-model="track.short_challenge.bonus_desc" clearable />
              </el-form-item>
              <el-form-item label="Shoutout Description" class="position">
                <el-input v-model="track.short_challenge.shoutout_desc" class="position"/>
              </el-form-item>
              <el-form-item label="Shoutout amount" class="position">
                <el-input type="number" v-model="track.short_challenge.shoutout_payment"></el-input>
              </el-form-item>
              <el-form-item label="Affiliate Description" class="position">
                <el-input v-model="track.short_challenge.affiliate_desc" class="position"/>
              </el-form-item>
              <el-form-item label="Discount Description" class="position">
                <el-input v-model="track.short_challenge.discount_desc" class="position"/>
              </el-form-item>
              <el-form-item label="Discount percentage" class="position">
                <el-input type="number" v-model="track.short_challenge.discount_value"></el-input>
              </el-form-item>
<!--              <el-form-item label="Earn Up" prop="short_challenge.earn_up">
                <el-input type="text" v-model="track.short_challenge.earn_up" clearable />
              </el-form-item>
              <el-form-item label="Free To Use" prop="short_challenge.free_to_use">
                <el-input type="text" v-model="track.short_challenge.free_to_use" clearable />
              </el-form-item>-->
            </div>
          </el-form-item>
          <el-form-item class ="item-dropdown">
            <div class="custom-form-title">
              <label class="custom-label">Campaign availability</label>
              <el-button type="default" @click="showShortsCampaignAvailability = !showShortsCampaignAvailability"
                         class="circle-button"
                         :icon="showShortsCampaignAvailability === true ? 'el-icon-top' : 'el-icon-bottom'"
                         circle></el-button>
            </div>
            <div v-if="showShortsCampaignAvailability">
              <el-form-item label="" class="position">
                <el-switch class="modal__affiliate" v-model="track.short_challenge.allow_rejected_user" active-text="Rejected users" inactive-text=""
                           active-color="#13ce66" inactive-color="#df2758"></el-switch>
              </el-form-item>
              <el-form-item label="" class="position">
                <el-switch class="modal__affiliate" v-model="track.short_challenge.allow_pending_user" active-text="Pending users" inactive-text=""
                           active-color="#13ce66" inactive-color="#df2758"></el-switch>
              </el-form-item>
            </div>
          </el-form-item>
          <div class="upload-content">
            <div class="upload-title" v-if="!track.short_challenge.video">Content example</div>
            <el-upload
              v-if="!track.short_challenge.video"
              drag
              ref="uploadChallengeVideo"
              :action="url + 'youtube-challenge/shorts/video/' + track.id"
              :headers="headers"
              :limit="1"
              name="video"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Drop file here or <em>click to upload</em>
              </div>
              <div class="el-upload__tip" slot="tip">*upload image or video</div>
            </el-upload>
            <el-form-item v-else label="Uploaded content" class="video-wrap">
              <div>
                <a :href="track.short_challenge.video" target="_blank">
                  {{ getOriginalVideoName(track.short_challenge.video) }}
                </a>
                <i class="el-icon-circle-close pointer ml5" @click="deleteShortVideo(track.id)"></i>
              </div>
            </el-form-item>
          </div>
          <el-form-item label="Link to sound" prop="short_challenge.link">
            <el-input type="text" v-model="track.short_challenge.link" clearable />
          </el-form-item>
<!--          <el-form-item label="Steps title" prop="short_title">
            <el-input type="text" v-model="track.short_challenge.campaign_main_title" clearable />
          </el-form-item>-->
          <el-form-item label="Steps" prop="short_challenge.steps">
            <vue-editor v-model="track.short_challenge.steps" />
          </el-form-item>
          <el-form-item label="Top tips" prop="short_challenge.top_tips">
            <vue-editor v-model="track.short_challenge.top_tips"  />
          </el-form-item>
          <el-form-item
            label="Challenge Date"
            prop="short_challenge.date_start"
            style="margin-bottom: 25px;"
          >
            <el-input
              type="hidden"
              v-model="track.short_challenge.date_start"
              clearable
              style="width: 0px;"
            />
            <el-date-picker
              v-model="shortDatePicker"
              type="daterange"
              format="d MMMM yyyy"
              value-format="yyyy-MM-dd"
              range-separator="-"
              start-placeholder="Start date"
              end-placeholder="End date"
              @change="changeShortPicker"
            ></el-date-picker>
          </el-form-item>
        </div>
      </div>
      <div class="youtube_data" v-if="hasSocial('YouTube')">
        <div  class="custom-form-title">
          <label class="custom-label">YouTube Regular</label>
          <el-button type="default" @click="youtubeStatus(youtubeData)"
                     class="circle-button"
                     :icon="youtubeData === true ? 'el-icon-top' : 'el-icon-bottom'"
                     circle></el-button>
        </div>
        <div v-if="youtubeData" class ="social-data youtube-bar">
          <div class="upload-content">
            <el-form-item label="" class="position">
              <el-switch  v-model="track.regular_challenge.multiple_submissions" active-text="Multiple submissions" inactive-text=""
                          active-color="#13ce66" inactive-color="#df2758"></el-switch>
            </el-form-item>
            <div class="upload-title" v-if="!track.regular_challenge.youtube_video">Content example</div>
            <el-upload
              v-if="!track.regular_challenge.youtube_video"
              drag
              ref="uploadYoutubeVideo"
              :action="url + 'talent-scout/track/youtube-video/' + track.id"
              :headers="headers"
              :limit="1"
              name="video"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Drop file here or <em>click to upload</em>
              </div>
              <div class="el-upload__tip" slot="tip">*upload image or video</div>
            </el-upload>
            <el-form-item v-else label="Uploaded content" class="video-wrap">
              <div>
                <a :href="track.regular_challenge.youtube_video" target="_blank">
                  {{ getOriginalVideoName(track.regular_challenge.youtube_video) }}
                </a>
                <i class="el-icon-circle-close pointer ml5" @click="deleteYoutubeVideo(track.id)"></i>
              </div>
            </el-form-item>
          </div>
<!--          <el-form-item label="Steps title" prop="challenge_title">
            <el-input type="text" v-model="track.regular_challenge.campaign_main_title" clearable />
          </el-form-item>-->
          <el-form-item label="Steps" prop="regular_challenge.steps">
            <vue-editor v-model="track.regular_challenge.steps" />
          </el-form-item>
          <el-form-item label="Top tips" prop="regular_challenge.top_tips">
            <vue-editor v-model="track.regular_challenge.top_tips" />
          </el-form-item>
          <el-form-item class="item-dropdown">
            <div class="custom-form-title">
              <label class="custom-label">Additional perks</label>
              <el-button type="default" @click="showYoutubePerks = !showYoutubePerks"
                         class="circle-button"
                         :icon="showYoutubePerks === true ? 'el-icon-top' : 'el-icon-bottom'"
                         circle></el-button>
            </div>
            <div v-if="showYoutubePerks" class="perks">
              <el-form-item label="Bonus Title" class="position">
                <el-input v-model="track.regular_challenge.bonus_title"></el-input>
              </el-form-item>
              <el-form-item label="Bonus Description" prop="tiktok_challenge.bonus_desc">
                <el-input type="text" v-model="track.regular_challenge.bonus_desc" clearable />
              </el-form-item>
              <el-form-item label="Affiliate Description" class="position">
                <el-input v-model="track.regular_challenge.affiliate_desc" class="position"/>
              </el-form-item>
              <el-form-item label="Discount Description" class="position">
                <el-input v-model="track.regular_challenge.discount_desc" class="position"/>
              </el-form-item>
              <el-form-item label="Discount percentage" class="position">
                <el-input type="number" v-model="track.regular_challenge.discount_value"></el-input>
              </el-form-item>
              <!--              <el-form-item label="Earn Up" prop="short_challenge.earn_up">
                              <el-input type="text" v-model="track.short_challenge.earn_up" clearable />
                            </el-form-item>
                            <el-form-item label="Free To Use" prop="short_challenge.free_to_use">
                              <el-input type="text" v-model="track.short_challenge.free_to_use" clearable />
                            </el-form-item>-->
            </div>
          </el-form-item>
<!--          <el-form-item label="Earn Up" prop="regular_challenge.earn_up">
            <el-input type="text" v-model="track.regular_challenge.earn_up"  clearable />
          </el-form-item>
          <el-form-item label="Free To Use" prop="regular_challenge.free_to_use">
            <el-input type="text" v-model="track.regular_challenge.free_to_use"  clearable />
          </el-form-item>-->
        </div>
      </div>
      <el-form-item label="NFT Description" prop="nft_description" v-if="false">
        <el-input type="text" v-model="track.nft_description" clearable />
      </el-form-item>
      <el-form-item label="Genres" prop="track_genres">
        <el-select v-model="track.track_genres" multiple placeholder="Select">
          <el-option
            v-for="item in genres"
            :key="item.id"
            :label="item.name.charAt(0).toUpperCase() + item.name.slice(1)"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Moods" prop="moods">
        <el-select v-model="track.moods" multiple placeholder="Select">
          <el-option
            v-for="item in moods"
            :key="item.id"
            :label="item.name.charAt(0).toUpperCase() + item.name.slice(1)"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="BPM" prop="bpm">
        <el-input type="text" v-model="track.bpm" clearable />
      </el-form-item>
      <el-form-item label="FFM Link" prop="ffm_link">
        <el-input type="text" v-model="track.ffm_link" clearable />
      </el-form-item>
      <el-form-item class="smart-links">
        <el-button @click="addSmartLink">Add Smart Link</el-button>
        <small>(You can add maximum 3 smart links)</small>
      </el-form-item>
      <div v-for="(link, index) in track.smartLinks" :key="link.key">
        <el-form-item class="smart-link-input" :label="`Smart Link ${index + 1}`"
                      :prop="'smartLinks.' + index + 'value'">
          <el-input v-model="link.value"></el-input>
          <el-button @click.prevent="removeSmartLink(link)">Delete</el-button>
        </el-form-item>
        <el-form-item class="smart-link-input" :label="`Smart Link Description ${index + 1}`"
                      :prop="'smartLinks.' + index + 'description'">
          <el-input v-model="link.description"></el-input>
        </el-form-item>
      </div>
      <el-form-item label="Description" prop="description">
        <el-input type="textarea" size="medium" maxlength="300" rows="5" :show-word-limit="true"
                  placeholder="Description" v-model="track.description"></el-input>
      </el-form-item>
      <el-form-item label="Blue box text" prop="card_bar_desc">
        <div class="vue_editor">
          <vue-editor
            placeholder="Enter text for card bar..."
            id="editor"
            v-model="track.card_bar_desc"
            :editorToolbar="customToolbar"/>
        </div>
      </el-form-item>
      <el-form-item label="Select Restrictions" prop="restrictions">
        <el-checkbox-group v-model="track.restrictions">
          <el-checkbox v-for="r in restrictions" :key="new Date().getTime() + r" :label="r"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item
        label="Timing"
        prop="date_start"
      >
        <el-input
          type="hidden"
          v-model="track.date_start"
          clearable
          style="width: 0px;"
        />
        <el-date-picker
          v-model="datePicker"
          type="daterange"
          format="d MMMM yyyy"
          value-format="yyyy-MM-dd"
          range-separator="-"
          start-placeholder="Start date"
          end-placeholder="End date"
          @change="changePicker"
        ></el-date-picker>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="info" size="mini" @click="previewTemplate">Preview</el-button>
      <el-button type="primary" size="mini" @click="submit()">
        {{ dialog_type }}
      </el-button>
    </div>
    <PreviewImport :track="dataForPreview" :restrictions="restrictions" />
  </el-dialog>
</template>

<script>
import UploadVideo from './UploadVideo'
import PreviewImport from '@/modules/admin/track-import/components/PreviewImportInMail'
import { mapState, mapActions, mapMutations } from 'vuex'
import { pick } from 'lodash'
import { VueEditor } from "vue2-editor";
import axios from '@/plugins/axios'

export default {
  data() {
    return {
      datePicker: [],
      shortDatePicker: [],
      tiktokDatePicker: [],
      tiktokData: false,
      instagramDatePicker: [],
      instagramData: false,
      shortsData:false,
      youtubeData:false,
      showYoutubePerks: false,
      showInstagramPricing: false,
      showInstagramPerks:false,
      showShortsPricing: false,
      showShortsPerks: false,
      showTikTokPricing: false,
      showTikTokPerks: false,
      showTikTokCampaignAvailability: false,
      showInstagramCampaignAvailability: false,
      showShortsCampaignAvailability: false,
      dataForPreview: {},
      url: process.env.VUE_APP_ADMIN_API_URL,
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      selectedImage: null,
      previewImage: null,
      customToolbar: [
        ["bold"]
      ]
    }
  },

  components: {
    PreviewImport,
    VueEditor,
  },
  computed: {
    ...mapState('newReleasesTracks', [
      'track',
      'dialog',
      'dialog_type',
      'genres',
      'moods',
      'restrictions',
      'tiktok_pricing',
      'instagram_pricing',
      'short_pricing',
      'socials'
    ]),
    ...mapState('trackImport', ['artists']),
    image() {
      return this.track.image_url instanceof File ? null : this.track.image_url
    }
  },

  methods: {
    ...mapActions('newReleasesTracks', ['create', 'update']),
    ...mapMutations('global', ['setPreview']),
    ...mapMutations('newReleasesTracks', [
      'setDialog',
      'setTrack',
      'setTiming',
      'setArtist',
      'setTrackSmartLinks',
      'setImage'
    ]),
    getOriginalVideoName(url) {
      let position = url.lastIndexOf('/')
      return url.substr(position + 1)
    },

    deleteVideo(trackId) {
      this.$confirm('This video will be deleted', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        axios.admin.delete(`talent-scout/track/video/${trackId}`)
          .then(res => {
            if (res.data.success) {
              this.track.tiktok_challenge.video = null
              this.$message(
                { message: 'You have successfully deleted video', type: 'success' }
              )
            }
          })
      })
    },
    deleteShortVideo(trackId) {
      this.$confirm('This video will be deleted', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        axios.admin.delete(`youtube-challenge/shorts/video/${trackId}`)
          .then(res => {
            if (res.data.success) {
              this.track.short_challenge.video = null
              this.$message(
                { message: 'You have successfully deleted video', type: 'success' }
              )
            }
          })
      })
    },
    deleteYoutubeVideo(trackId) {
      this.$confirm('This video will be deleted', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        axios.admin.delete(`talent-scout/track/youtube-video/${trackId}`)
          .then(res => {
            if (res.data.success) {
              this.track.regular_challenge.youtube_video = null
              this.$message(
                { message: 'You have successfully deleted video', type: 'success' }
              )
            }
          })
      })
    },
    deleteInstagramVideo(trackId) {
      this.$confirm('This video will be deleted', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        axios.admin.delete(`instagram-challenge/video/${trackId}`)
          .then(res => {
            if (res.data.success) {
              this.track.instagram_challenge.video = null
              this.$message(
                { message: 'You have successfully deleted video', type: 'success' }
              )
            }
          })
      })
    },
    previewTemplate() {
      this.dataForPreview = {
        ...pick(this.track, [
            'description', 'title', 'smartLinks', 'ffm_link', 'restrictions'
        ]),
        artist: { name: this.track.artist_name }
      }
      this.setPreview(true)
    },

    submit() {
      if (this.selectedImage) this.setImage(this.selectedImage)
      //if(this.track.type != 'nft') this.track.nft_description = null
      if (this.dialog_type === 'Create') {
        this.create()
      } else if (this.dialog_type === 'Edit') {
        this.update(this.track.id)
      }
    },

    open() {
      this.datePicker = []
      if (
        typeof this.track.date_start !== 'undefined' &&
        typeof this.track.date_end !== 'undefined' &&
        this.track.date_start !== null &&
        this.track.date_end !== null
      ) {
        this.datePicker[0] = this.track.date_start
        this.datePicker[1] = this.track.date_end
      }

      this.shortDatePicker = []
      if (
        typeof this.track.short_challenge.date_start !== 'undefined' &&
        typeof this.track.short_challenge.date_end !== 'undefined' &&
        this.track.short_challenge.date_start !== null &&
        this.track.short_challenge.date_end !== null
      ) {
        this.shortDatePicker[0] = this.track.short_challenge.date_start
        this.shortDatePicker[1] = this.track.short_challenge.date_end
      }

      this.tiktokDatePicker = []
      if (
        typeof this.track.tiktok_challenge.date_start !== 'undefined' &&
        typeof this.track.tiktok_challenge.date_end !== 'undefined' &&
        this.track.tiktok_challenge.date_start !== null &&
        this.track.tiktok_challenge.date_end !== null
      ) {
        this.tiktokDatePicker[0] = this.track.tiktok_challenge.date_start
        this.tiktokDatePicker[1] = this.track.tiktok_challenge.date_end
      }
      this.instagramDatePicker = []
      if (
        typeof this.track.instagram_challenge.date_start !== 'undefined' &&
        typeof this.track.instagram_challenge.date_end !== 'undefined' &&
        this.track.instagram_challenge.date_start !== null &&
        this.track.instagram_challenge.date_end !== null
      ) {
        this.instagramDatePicker[0] = this.track.instagram_challenge.date_start
        this.instagramDatePicker[1] = this.track.instagram_challenge.date_end
      }
      this.previewImage = null
      this.selectedImage = null
      this.setImage(null)
    },

    changePicker() {
      if (typeof this.datePicker !== 'undefined' && this.datePicker !== null) {
        this.setTiming({
          date_start: this.datePicker[0],
          date_end: this.datePicker[1]
        })
      } else {
        this.setTiming({
          date_start: null,
          date_end: null
        })
      }
    },
    changeShortPicker() {
      if (typeof this.shortDatePicker !== 'undefined' && this.shortDatePicker !== null) {
        this.track.short_challenge.date_start = this.shortDatePicker[0]
        this.track.short_challenge.date_end = this.shortDatePicker[1]
      } else {
          this.track.short_challenge.date_start = null
          this.track.short_challenge.date_end =  null
      }
    },
    changeTikTokPicker() {
      if (typeof this.tiktokDatePicker !== 'undefined' && this.tiktokDatePicker !== null) {
        this.track.tiktok_challenge.date_start = this.tiktokDatePicker[0]
        this.track.tiktok_challenge.date_end = this.tiktokDatePicker[1]
      } else {
        this.track.tiktok_challenge.date_start = null
        this.track.tiktok_challenge.date_end =  null
      }
    },
    changeInstagramPicker() {
      if (typeof this.instagramDatePicker !== 'undefined' && this.instagramDatePicker !== null) {
        this.track.instagram_challenge.date_start = this.instagramDatePicker[0]
        this.track.instagram_challenge.date_end = this.instagramDatePicker[1]
      } else {
        this.track.instagram_challenge.date_start = null
        this.track.instagram_challenge.date_end =  null
      }
    },
    hasSocial(social) {
      let findSocial = this.socials.find(s => s.name === social)

      if (findSocial && this.track.socials) {
        return !!this.track.socials.find(s => s === findSocial.id)
      }
      return false
    },

    addSmartLink() {
      let trackSmartLink = this.track.smartLinks
      if (trackSmartLink && trackSmartLink.length === 3) return

      trackSmartLink.push({key: new Date().getTime(), value: ''})
      this.setTrackSmartLinks(trackSmartLink)
    },

    removeSmartLink(link) {
      let trackSmartLink = this.track.smartLinks
      const index = trackSmartLink.indexOf(link);

      if (index !== -1) {
        trackSmartLink.splice(index, 1);
      }
      this.setTrackSmartLinks(trackSmartLink)
    },
    openPreview(sometext) {
      this.setPreview(true)
      this.text = sometext
    },
    close() {
      this.setDialog(false)
      this.previewImage = null;
    },
    uploadImage(event) {
      if (event.target.files && event.target.files[0]) {
        let base64 = null
        // Encode the file using the FileReader API
        const reader = new FileReader();
        reader.onloadend = () => {
          // Use a regex to remove data url part
          this.selectedImage = reader.result
        };
        reader.readAsDataURL(event.target.files[0]);
        this.previewImage = URL.createObjectURL(event.target.files[0])
      }
    },

    removeImage() {
      this.track.image_url = null
      this.setImage(null)
      this.selectedImage = null
      this.previewImage = null
    },
    tiktokStatus(info){
      this.tiktokData = !info
    },
    instagramStatus(info){
      this.instagramData = !info
    },
    shortsStatus(info){
      this.shortsData = !info
    },
    youtubeStatus(info){
      this.youtubeData = !info
    },
    handleSwitchChange(type) {
      // Ensure only one switch is active
      if (type === 'signup_generator' && this.track.affiliate_signup_generator === 1) {
        this.track.affiliate_track_generator = 0;
      } else if (type === 'track_generator' && this.track.affiliate_track_generator === 1) {
        this.track.affiliate_signup_generator = 0;
      }
    },
    handleUploadSuccess(response, file, fileList) {
      // Handle file upload success
      console.log('Upload success:', response, file, fileList);
      // You can handle the response from Laravel API here
      // Example: Update state or show a success message
      this.$message.success('File uploaded successfully');
    },
    handleUploadError(err, file, fileList) {
      // Handle file upload error
      console.error('Upload error:', err, file, fileList);
      // You can handle the error, show a message, etc.
      this.$message.error('File upload failed');
    },
    beforeUpload(file) {
      // Implement any checks before upload (e.g., file type, size)
      const isXLS = file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const maxSizeMB = 10; // Maximum file size in MB

      if (!isXLS) {
        this.$message.error('Please upload Excel file (XLS or XLSX)');
        return false; // Cancel upload
      }

      if (file.size / 1024 / 1024 > maxSizeMB) {
        this.$message.error(`File size exceeds ${maxSizeMB}MB limit`);
        return false; // Cancel upload
      }

      return true; // Continue with upload
    }
  }
}
</script>

<style scoped lang="scss">

.form-wrapper{
    font-family: "F37 Ginger Pro";
}
label.el-checkbox {
  display: inline-block;
}

.smart-links {
  small {
    margin-left: 10px;
  }
}

.smart-link-input {
  .el-input {
    width: 70%;
    margin-right: 10px;
  }
}
.video-wrap {
  div {
    display: flex;
    align-items: center;
  }
}
.tiktok_data, .shorts_data, .youtube_data, .instagram_data{

  .social-data{
    border-left: 4px solid rgb(230, 162, 60);
    padding: 0 20px;
    margin: 0;
  }
  .shorts-bar{
    border-color:rgb(230, 162, 60);
  }
  .tiktok-bar{
    border-color:rgb(48, 49, 51);
  }
  .instagram-bar{
    border-color:rgb(245, 218, 66);
  }
  .youtube-bar{
    border-color:#F56C6C;
  }
  .title{
    color:#000;
    text-transform: uppercase;
    border-bottom: 1px solid;
    text-align: center;
    cursor: pointer;
    padding-bottom: 10px;
  }
  .arrow {
    border: solid black;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
  }
  .up {
    transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
  }

  .down {
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
  }
}
.pricing_table{
  border: 1px solid #ccc;
  padding: 10px;
  margin: 10px 0;
  width: 100%;
  tr{
    border: 1px solid;
  }
}
.pricing_label{
  font-size: 16px;
  color: #0E0525;
  line-height: 23px;
}
.image {
  &--uploader {
    label {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
      width: 120px;
      height: 120px;
      border: 1px dashed #d9d9d9;
      cursor: pointer;
    }
  }
  &--preview {
    text-align: center;
    position: relative;

    img{
      object-fit: cover;
    }

    &:hover {
      .overlay {
        display: flex;
        .btn-remove{
          background: red;
          color: white;
          margin-top: unset;
          cursor: pointer;
        }
      }
    }

    .overlay {
      position: absolute;
      z-index: 5;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 120px;
      height: 100%;
      background: rgba(0, 0, 0, .1);
      display: none;
      align-items: center;
      justify-content: center;
    }
  }
}
.vue_editor{
  height: 100px;
  border-bottom:1px solid rgb(204, 204, 204);
  overflow: hidden;
  //border-top:1px solid rgb(204, 204, 204);
}
#editor{
  height: 50px !important;
}
.custom-form-title{
  display: flex;
  margin: 10px 0;
}
.custom-label{
  margin-right: 10px;
  text-align: left;
  word-break: break-word;
  font-size: 16px;
  color: #0E0525;
  line-height: 45px;
  min-height: 45px;
}
.circle-button{
  height: 25px;
  width: 25px;
  padding: 0;
  margin-top: 10px;
}
.upload-content .upload-title{
  text-align: left;
  word-break: break-word;
  font-size: 16px;
  color: #0E0525;
  line-height: 45px;
  min-height: 45px;
}
</style>
